'use strict';

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var usePrevious = function usePrevious(value) {
  var ref = react.useRef();
  react.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

usePrevious.HOOK_ID = 'Gearz.ReactHooks.usePrevious';
usePrevious.returnType = PropTypes__default["default"].anyWithDescription('Previous value.');
usePrevious.parameterTypes = {
  value: PropTypes__default["default"].anyWithDescription('Value to save its previous value.')
};
usePrevious.defaultParameters = {
  value: undefined
};

module.exports = usePrevious;
